import { render, staticRenderFns } from "./DefectClasses.vue?vue&type=template&id=3308725d&scoped=true"
import script from "./DefectClasses.vue?vue&type=script&lang=js"
export * from "./DefectClasses.vue?vue&type=script&lang=js"
import style0 from "./DefectClasses.vue?vue&type=style&index=0&id=3308725d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3308725d",
  null
  
)

export default component.exports